import React from 'react';
import GuestGrid from './Tab_Guest_Grid';
import AddGuest from './AddGuest';
import HostPortalActions from './HostPortalActions';

export default class GuestsTab extends React.Component {
	constructor(props) {
		super(props);
		this.state = {}
	}

	componentWillMount() {
		if(this.props.guestStatusList.length == 0)
			HostPortalActions.getGuestStatuses();
	}

	setFilter(key, code) {
		HostPortalActions.setSelectedStatus(code);
	}

	render() {
		return (
			<div className="active clearfix animate-in">
				<AddGuest {...this.props} />
				<div style={{clear: "both"}}></div>
				<div className="spacer12"></div>
				<div className="spacer12"></div>
				<GuestGrid {...this.props} setFilter={this.setFilter.bind(this)} />
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/Tab_Guests.js